import { startCase } from 'lodash';

const ROMAN_NUMERAL_REGEX = /^(XC|XL|L?X{0,3})(IX|IV|V?I{0,3})$/;

export const formatShipName = (shipName: string) =>
  shipName
    .split(' ')
    .map(s => (ROMAN_NUMERAL_REGEX.test(s) ? s : startCase(s.toLowerCase())))
    .join(' ');
